module.exports = __webpack_public_path__ + "static/img/img-profile-institution.4da9cb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user/img-profile-institution.svg
// module id = 488
// module chunks = 1